module.exports = __webpack_public_path__ + "static/img/healthAd1.bd47a4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/healthAd1.jpg
// module id = IrfN
// module chunks = 1